import { useTranslation } from "react-i18next";

/** A small ring that inherits the text colour. Static under reduced motion (the global rule stops it). */
export function Spinner({ className = "size-[1.125rem]", label }: { className?: string; label?: string }) {
	const { t } = useTranslation();
	return (
		<svg
			viewBox="0 0 24 24"
			role="img"
			aria-label={label ?? t("state.loading")}
			className={`animate-spin ${className}`}
			fill="none"
		>
			<circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
			<path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
		</svg>
	);
}
